<template>
  <div class="body-section">
    <div>
      <div class="title-section" style="display: flex">
        <h1 class="title title-ruban">RESULTATS</h1>
        <div>
          <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <li>
                <router-link to="Dashboard">
                  <span class="icon is-small">
                    <i class="fas fa-chevron-left" aria-hidden="true"></i>
                  </span>
                  <span>Accueil</span>
                </router-link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="page-seperate"></div>
    </div>
    <div class="container mt-5">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link to="Dashboard">
              <span class="icon is-small">
                <i class="fas fa-chevron-left" aria-hidden="true"></i>
              </span>
              <span>Accueil</span>
            </router-link>
          </li>
        </ul>
      </nav>
      <div class="columns is-centered">
        <div class="column is-half">
          <result-card
            v-for="(result, index) in results"
            :key="index"
            :surveyResult="result"
            :userName="$store.state.user.nameSurname"
            :userPosition="$store.state.user.position"
          >
          </result-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResultCard from "@/components/ResultCard.vue";

export default {
  components: { ResultCard },
  props: {
    results: Array,

    // dictionnary
    // suvey
  },
};
</script>

<style lang="scss" scoped></style>
